import { useParams, Navigate } from 'react-router';
import { useGetProgramDetail } from '../api/useProgram';
import { DetailHeader, Section } from '../components/DetailSection';
import { ProgramStatusBadge } from '../components/ProgramStatusBadge';
import { ProgramProfile } from '../components/ProgramProfile';
import { ProgramSummaryCards } from '../components/ProgramSummaryCards';
import { ProgramGuestsTable } from '../components/ProgramGuestsTable';
import { ProgramTerminalsTable } from '../components/ProgramTerminalsTable';

export const ProgramDetail = () => {
  const { uid } = useParams();
  const { data, isLoading, isError } = useGetProgramDetail(uid ?? '');

  if (!uid) return <Navigate to="/programs" replace />;
  if (isLoading) return <div className="text-sm text-gray-500">Loading...</div>;

  const program = data?.payload?.program;
  if (isError || !program) return <div className="text-sm text-red-500">Program not found.</div>;

  return (
    <div className="flex flex-col gap-6">
      <DetailHeader
        backTo="/programs"
        backLabel="Programs"
        title={program.name}
        badges={<ProgramStatusBadge program={program} />}
      />
      <ProgramProfile program={program} />
      <ProgramSummaryCards uid={uid} />
      <Section title="Members">
        <ProgramGuestsTable uid={uid} />
      </Section>
      <Section title="Terminals">
        <ProgramTerminalsTable uid={uid} />
      </Section>
    </div>
  );
};
